import { render, staticRenderFns } from "./navbar-notification.vue?vue&type=template&id=e1beddc4&scoped=true&"
import script from "./navbar-notification.vue?vue&type=script&lang=js&"
export * from "./navbar-notification.vue?vue&type=script&lang=js&"
import style0 from "./navbar-notification.vue?vue&type=style&index=0&id=e1beddc4&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e1beddc4",
  null
  
)

export default component.exports